import { collectionEngineV1 } from '../apis.js';
const reqBlameLogs = collectionEngineV1('/blame-logs');
export const createBlameLog = (blameLog, tenantId) => reqBlameLogs('POST', '/', {
    body: { blameLog: blameLog, tenantId: tenantId },
});
export const getBlameLogs = (refType, refId, filter, page, pageSize) => reqBlameLogs('GET', `/${refType}/${refId}?${new URLSearchParams({ page: (page ?? 0).toString(), pageSize: (pageSize ?? 25).toString(), filter: JSON.stringify(filter) })}`, {});
//# sourceMappingURL=blame-logs.js.map